var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBikeRepairStationinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M18 46h2.4c.884 0 1.6.768 1.6 1.714v2.572c0 .946-.716 1.714-1.6 1.714H18m29 0h-2.4c-.884 0-1.6-.768-1.6-1.714v-2.572c0-.946.716-1.714 1.6-1.714H47m-25 3h21"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 33,
  r: 7,
  strokeLinecap: "square",
  transform: "matrix(-1 0 0 1 90 0)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 33,
  r: 7,
  strokeLinecap: "square",
  transform: "matrix(-1 0 0 1 38 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23 16 7.5 17"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M26 16h-6m17 0h2.252a1 1 0 0 1 .96.718L45 33"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M41 21H25l-6 12h11.674z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 54,
  x: 5,
  y: 5,
  strokeLinecap: "square",
  rx: 4
}))));
export default SvgBikeRepairStationinline;